import { Component, OnInit } from '@angular/core';
import { AmountRangeCIF } from '../../../shared/viewmodels/UtilityObj';
import { Store } from '@ngrx/store';
import { CoreSearchDataState as AppState, getRegSearchState } from '../../../store/reducers/reducers';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
//import { isNumeric } from 'rxjs-compat/util/isNumeric';
import { AmountRangeMustBeValid } from '../../../shared/helpers/amount-range.validator';

@Component({
  selector: 'app-amountrange',
  templateUrl: './amountrange.component.html',
  styleUrls: ['./amountrange.component.css']
})
export class AmountrangeComponent implements OnInit {
  public utilityobj: AmountRangeCIF;
  message: any;
  public form: UntypedFormGroup;
  public myFromAmount: string;
  constructor(private store: Store<AppState>, private fb: UntypedFormBuilder) {
    this.utilityobj = new AmountRangeCIF();
    this.store.select(getRegSearchState).subscribe(data => this.message = data);
    if (this.message.amount[0] != null) {
      this.utilityobj.fromAmount = this.message.amount[0].fromAmount;
      this.utilityobj.toAmount = this.message.amount[0].toAmount;
      this.utilityobj.type = this.message.amount[0].type;

    }

  }

  ngOnInit() {
    this.form = this.fb.group({
      'fromamount': [this.utilityobj.fromAmount, Validators.required],
      'toamount': [this.utilityobj.toAmount, Validators.required],
      'type': [this.utilityobj.type]
    }, {validators: AmountRangeMustBeValid()});

    if (this.utilityobj.type == "lte" || this.utilityobj.type == "gte") {
      this.form.get('toamount').clearValidators();
      this.form.get('toamount').updateValueAndValidity();
    }

    this.form.get('type').valueChanges.subscribe(value => {
      console.log(`type valueChanges value: ${JSON.stringify(value)}`);
      this.utilityobj.type = value;

      if (value == "lte" || value == "gte") {
        //this.form.patchValue({ toamount: 0 });
        this.form.get('toamount').clearValidators();
        
      } else {
        this.form.get('toamount').setValidators(Validators.required);
      }
      this.form.get('toamount').updateValueAndValidity();
    });
    this.form.valueChanges.subscribe(value => {
      console.log(`value: ${JSON.stringify(value)}`);
      console.log(`form.get('toamount').errors: ${JSON.stringify(this.form.get('toamount').errors)}`);
      //console.log(`form.errors: ${JSON.stringify(this.form.errors)}`);
      //console.log(`this.value: ${this.utilityobj.type}`);
      //console.log(`isNumeric(value.fromamount): ${isNumeric(value.fromamount)}`);
      //console.log(`Number(value.fromAmount): ${Number(value.fromamount)}`);
      //console.log(`myFromAmount before assignment: ${this.myFromAmount}`);

      //this.utilityobj.fromAmount = isNumeric(value.fromamount) ? Number(value.fromamount) : this.utilityobj.fromAmount;


      if (this.form.valid) {

        this.utilityobj.fromAmount = !isNaN(+value.fromamount) ? +value.fromamount : this.utilityobj.fromAmount;
        console.log(`myFromAmount after assignment: ${this.myFromAmount}`);
        this.utilityobj.toAmount = !isNaN(+value.toamount) ? Number(value.toamount) : this.utilityobj.toAmount;
        console.log(`form.get('fromamount').value: ${this.form.get('fromamount').value}`);

      }
    });

  }

}
